import Icon from "../Icon";
import { NotionLogo } from "../widgets/NotionOrigen";

// El icono de origen de una tarea: paso de proyecto (diagrama) o página de Notion («N»).
// Se usa igual en el selector de tarea, en Mis tareas y en la fila de la entrada del
// Cuaderno. El nombre va en texto para lectores de pantalla y en el tooltip.
export const NOMBRE_ORIGEN = { proyecto: "Paso de proyecto", paso: "Paso de proyecto", notion: "Página de Notion",
  suelta: "Tarea enviada", encargo: "Tarea enviada" };

export default function OrigenIcono({ origen, size = 11 }) {
  const nombre = NOMBRE_ORIGEN[origen] || NOMBRE_ORIGEN.proyecto;
  return (
    <span className="mt-origen" title={nombre} style={{ display: "inline-flex", alignItems: "center", flex: "none" }}>
      {origen === "notion" ? <NotionLogo title={nombre} />
        : origen === "suelta" || origen === "encargo" ? <Icon name="person" size={size} color="currentColor" />
        : <Icon name="diagram-3" size={size} color="currentColor" />}
      <span className="sr-only">{nombre}</span>
    </span>
  );
}
